var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bg"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('LandingHeader'),_c('center',[_c('div',{staticClass:"heading"},[_c('h1',[_vm._v("Thanks for your interest! 🙏")]),_c('h3',[_vm._v("if you'd like to book a demo immediately, please select a time below")]),_c('div',{attrs:{"id":"calendly"}})])])],1),_c('LandingFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }